import { Component, OnInit } from '@angular/core';
import { GoogleLoginService } from '../../calendar/calendar.service';
import { GoogleAuthService, GoogleApiService } from 'ng-gapi';
import { Router } from '@angular/router';
import { Theme } from '../../shared/service/AutoTheme';
@Component({
  selector: 'app-glogins',
  templateUrl: './glogins.component.html',
  styleUrls: ['./glogins.component.css']
})
export class GloginsComponent implements OnInit {

  public glogin: boolean = false
  public spinner: boolean = true
  public mesg: any;
  calendershow: boolean = false
  constructor(private googleLoginService: GoogleLoginService, private authService: GoogleAuthService, private gapiService: GoogleApiService, protected router: Router, public theme: Theme) {
    this.gapiService.onLoad().subscribe();
    this.theme.showMenu(true);
    this.theme.ChangeEvent(0);
  }

  ngOnInit() {

      this.googleLoginService.getService().subscribe(res => {
      console.log(res);
      if (res.length > 0) {
        if (res[0].access_token) {
          console.log("res check");
          this.mesg = 'Please wait...';

          if (res[0].status == 3) 
          {
            // this.router.navigate(['/calendar']);
            this.spinner = false;

          }

          else if (res[0].status >= 0 && res[0].status < 3) {
            console.log("res[0].status>=0 && res[0].status<3");
            this.mesg = 'Please wait... Calendar is being sync.';
            this.spinner = true;
            this.glogin = false;
            setTimeout(() => {
              window.location.reload();
            }, 30000);
          }
          else if (res[0].status == 4) {
            console.log("res[0].status==4");
            this.mesg = 'Please wait... Current calendar access is being deleted.';
            this.spinner = true;
            this.glogin = false;
            // setTimeout(() => {
            //   window.location.reload();
            // }, 30000);
          }
          else if (res[0].status < 0) {
            console.log("res[0].status<0");
            this.spinner = false;
            this.glogin = true;
          }
        }
        else {
          console.log("res null");
          this.spinner = false;
          this.glogin = true;
        }
      }
    },
      err => {
        console.log("res null");
        this.spinner = false;
        this.glogin = true;
      });


  }

  public isLoggedIn(): boolean {
    return this.googleLoginService.isUserSignedIn();
  }

  public signIn() {
    console.log("sign in clicked");
    this.mesg = 'If popup is blocked please allow first.';
    this.spinner = true;
    this.glogin = false;
    this.googleLoginService.signIn();
  }

}
